import type { FaireProductEntity } from "../../entity_types/product";

export const p_ccmdttq9na: FaireProductEntity = {
  token: "p_ccmdttq9na",
  type: "product",
  name: "Vintage Honey Bottle Sampler Gift Set",
  brandToken: "b_2hhbtdht4d",
  brandName: "The Beekeeper's Daughter",
  imageUrl:
    "https://cdn.faire.com/fastly/29bf183dffaed882883cf63ed0d4d098bd88f3c7011bf2a431c749d80e37da5a.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/68047708e31be7967d97bbcac7b22dd7f6144d681306983566e7d095f0c0637a.jpeg",
  ],
  priceDollars: 24.94,
  description:
    "These 4oz. Vintage Honey Bottles are sealed with a cork and hand dipped in beeswax. This sampler set make the perfect gift for you or a loved one. Gift set includes 4 - 4oz. bottles of honey in Orange Blossom, Saw Palmetto, Wildflower, and Buckwheat Blossom.",
  tags: [],
  msrpDollars: 41.56,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:56:36.637Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
